export function isMobile () {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

export function isAndroid () {
  return /Android/i.test(navigator.userAgent)
}

export function isIOS () {
  return /iPhone|iPad/i.test(navigator.userAgent)
}

export function isNfPlus () {
  return /NFAPP/i.test(navigator.userAgent)
}

export function isWeChat () {
  return /MicroMessenger/i.test(navigator.userAgent)
}
